export default {
    namespaced: true,

    state: {
        locations: []
    },

    getters: {
        locations (state) {
            return state.locations
        }
    },

    mutations: {
        SET_LOCATIONS (state, value) {
            state.locations = value
        }
    },

    actions: {
        setLocations({commit}, data) {
            commit('SET_LOCATIONS', data)
        }
    }
}
